import React, {useState} from "react";
import Style from "../components/Style.module.css";
import {useEffectOnce} from "../hooks/useEffectOnce";
import {useSearchParams} from "react-router-dom";
import {callVerifyEmail} from "../api/UserService";

function VerifyEmailPage() {
    const [emailVerified, setEmailVerified] = useState(false)
    const [requestComplete, setRequestComplete] = useState(false)
    const [queryParams] = useSearchParams()

    function handleSuccess() {
        setRequestComplete(true)
        setEmailVerified(true)
    }

    function handleFailure() {
        setRequestComplete(true)
        setEmailVerified(false)
    }

    useEffectOnce(() => {

        callVerifyEmail(queryParams.get("token"), handleSuccess, handleFailure)
    }, [])


    return (
        <div>
        {!requestComplete &&
            <h>Перевіряємо ваш email. Якщо це повдомлення не зникне протягом декількох хвилин - напишіть на
                support@leelaonline.net</h>}
        {requestComplete && emailVerified &&
            <div className={Style.startPageMain}>
                <h>Вітаємо, ваш email підтверджено</h>
                <br />
                <br />
                <br />
                <br />
                <a className={`${Style.defaultButtonColourAndText} ${Style.buttonWithLink}`}
                   href={"/login"}>Login</a>
            </div>
        }
        {requestComplete && !emailVerified &&
            <div className={Style.startPageMain}>
                <h>Нажаль сталась помилка, ми не змогли підтвержити ваш email.</h>
                <br />
                <br />
                <h>Якщо ви копіювали посилання - перевірте його ще раз</h>
                <br />
                <br />
                <h>Якщо ви переконані що все зробили вірно - напишіть на support@leelaonline.net</h>
            </div>
        }


        </div>
    )
}

export default VerifyEmailPage